import React from "react";
import ReactDOM from "react-dom";
import classNames from "classnames";

class SchoolSwitcherDropdown extends React.Component {
  state = {};

  constructor(props) {
    super(props);
    this.toggleDropdown = this.toggleDropdown.bind(this);
  }

  toggleDropdown(e) {
    e.preventDefault();
    this.setState({
      isDroppedDown: !this.state.isDroppedDown,
    });
  }

  componentDidMount() {
    document.addEventListener("click", this.handleClickOutside, true);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside, true);
  }

  handleClickOutside = (e) => {
    const domNode = ReactDOM.findDOMNode(this);
    if (!domNode || !domNode.contains(e.target)) {
      this.setState({
        isDroppedDown: false,
      });
    }
  };

  render() {
    let dropdownClass = classNames({
      dropdown: true,
      "dropdown--is-visible": this.state.isDroppedDown,
    });
    return (
      <li className="other-apps__app-icon app-icon--apps apps-dropdown">
        <button
          target="_blank"
          rel="noopener noreferrer"
          alt="app"
          onClick={this.toggleDropdown}
          className="apps-links has-dropdown cpanel-tooltip"
        >
          <img
            alt="Wordpress Dropdown Icon"
            src="https://cdn.realsmart.co.uk/new-cpanel/wordpress_icon.png"
            className="app-icon app-icon-gmail"
          />
          <span className="tooltiptext">Websites</span>
        </button>
        <ul id="school__sites__dropdown" className={dropdownClass}>
          {this.props.schools.length === 0 && (
            <div className="apps-label">
              <span className="school__sites__dropdown-label__title">
                No Sites Available.
              </span>
            </div>
          )}
          {this.props.schools.length > 0 && (
            <div>
              {this.props.schools.map((school, i) => (
                <li className="school__sites__dropdown--item" key={i}>
                  <img
                    src={
                      school.sc_logo !== "undefined" && school.sc_logo != null
                        ? "https://cdn.realsmart.co.uk/sc_logos/" +
                          school.sc_logo
                        : "https://cdn.realsmart.co.uk/new-cpanel/school-logo-placeholder.png"
                    }
                    alt="realsmart logo"
                  />

                  <a
                    href={school.sc_wordpress_url + "wp-admin"}
                    target="_blank"
                    rel="noopener noreferrer"
                    alt="app"
                    className=""
                  >
                    <span>{school.sc_name}</span>
                  </a>
                </li>
              ))}
            </div>
          )}
        </ul>
      </li>
    );
  }
}

export default SchoolSwitcherDropdown;
